import { api } from 'common';

import { IteratorBlockFormFields } from './FormFields';
import { IteratorBlockDocumentationMarkdown } from './documentation';
import type { BlockConfigProps } from '../../../types';
import { SubFlowNodeOutputContent } from '../../SubFlow/OutputContent';
import { getSubFlowBlockDefaultConfig } from '../../SubFlow/v2/constants';

export const iteratorV2Config: BlockConfigProps<api.FlowDefinition.IteratorV2Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'iterator',
  defaultConfig: {
    items: '',
    subFlow: getSubFlowBlockDefaultConfig(),
    iterationStepDuration: {
      value: '0',
      units: api.FlowDefinition.DurationUnits.Seconds,
    },
  },
  configFields: {
    schema: api.FlowDefinition.IteratorV2BlockConfigSchema,
    FormFields: IteratorBlockFormFields,
  },
  documentationMarkdown: IteratorBlockDocumentationMarkdown,
  OutputContentComponent: SubFlowNodeOutputContent,
};
